import { parseToken } from './apiParser.helpers'

export const formatTokens = (tokens) => {
  if (tokens && tokens.length > 0) {
    return tokens.map((token) => parseToken(token))
  }
  return []
}
